/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Node } from 'react';

import React from 'react';
import { Alert, Col, Row } from 'reactstrap';

type Props = {|
  advisories: ?Array<{| code: string, message: string |}>,
  top?: string,
|};

const ADVISORY_TITLE = {
  MULTIPLE_BUILDINGS: 'Multiple buildings',
  MODEL_TYPE_MISMATCH: 'Model type mismatch',
};

/*
 * The model's own `advisories` column (data & API design §2.3/AD-10), shown on any open
 * of the model (UI design §2.3/§3, AU-6/AU-10) -- not only at the moment extraction
 * completes. v1 has no dismiss/acknowledge state, so this renders for as long as the
 * model carries the advisory.
 */
const AdvisoryBanner = ({ advisories, top = '0' }: Props): Node => {
  if (!advisories || advisories.length === 0) {
    return null;
  }
  return (
    <Row style={{ marginTop: top }}>
      {/* Aligned to the same md="10"/offset-2 column as Sidebar/MainContentArea (both
          fixed-position, starting at this same top offset) so the banner doesn't render
          underneath the sidebar. */}
      <Col md={{ size: 10, offset: 2 }}>
        {advisories.map(advisory => (
          <Alert key={advisory.code} className="advisory-banner" color="warning">
            <strong>{ADVISORY_TITLE[advisory.code] || advisory.code}:</strong> {advisory.message}
          </Alert>
        ))}
      </Col>
    </Row>
  );
};

export default AdvisoryBanner;
